"use client"

import { createContext, useContext, useState, type ReactNode } from "react"

type OrderAnimationContextType = {
  triggerOrderAnimation: () => void
  isAnimating: boolean
}

const OrderAnimationContext = createContext<OrderAnimationContextType | undefined>(undefined)

export function OrderAnimationProvider({ children }: { children: ReactNode }) {
  const [isAnimating, setIsAnimating] = useState(false)

  const triggerOrderAnimation = () => {
    setIsAnimating(true)
    // Reset animation after 2 seconds
    setTimeout(() => {
      setIsAnimating(false)
    }, 2000)
  }

  return (
    <OrderAnimationContext.Provider
      value={{
        triggerOrderAnimation,
        isAnimating
      }}
    >
      {children}
    </OrderAnimationContext.Provider>
  )
}

export function useOrderAnimation() {
  const context = useContext(OrderAnimationContext)
  if (context === undefined) {
    throw new Error("useOrderAnimation must be used within an OrderAnimationProvider")
  }
  return context
} 